import { updater as newUpdater } from './updater';

export const updaterStore = () => {
  const updaters = {};

  return (parentId, id, updaterOptions) => {
    if (!updaters[parentId]) {
      updaters[parentId] = {};
    }

    if (!updaters[parentId][id]) {
      updaters[parentId][id] = newUpdater(updaterOptions);
    }

    return updaters[parentId][id];
  };
};
